/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationProperties200ResponseMeta } from './GetOrganizationProperties200ResponseMeta';
import {
    GetOrganizationProperties200ResponseMetaFromJSON,
    GetOrganizationProperties200ResponseMetaFromJSONTyped,
    GetOrganizationProperties200ResponseMetaToJSON,
    GetOrganizationProperties200ResponseMetaToJSONTyped,
} from './GetOrganizationProperties200ResponseMeta';
import type { PropertyLinkedContact } from './PropertyLinkedContact';
import {
    PropertyLinkedContactFromJSON,
    PropertyLinkedContactFromJSONTyped,
    PropertyLinkedContactToJSON,
    PropertyLinkedContactToJSONTyped,
} from './PropertyLinkedContact';

/**
 * 
 * @export
 * @interface GetPropertyContacts200Response
 */
export interface GetPropertyContacts200Response {
    /**
     * 
     * @type {Array<PropertyLinkedContact>}
     * @memberof GetPropertyContacts200Response
     */
    contacts: Array<PropertyLinkedContact>;
    /**
     * 
     * @type {GetOrganizationProperties200ResponseMeta}
     * @memberof GetPropertyContacts200Response
     */
    meta?: GetOrganizationProperties200ResponseMeta;
}

/**
 * Check if a given object implements the GetPropertyContacts200Response interface.
 */
export function instanceOfGetPropertyContacts200Response(value: object): value is GetPropertyContacts200Response {
    if (!('contacts' in value) || value['contacts'] === undefined) return false;
    return true;
}

export function GetPropertyContacts200ResponseFromJSON(json: any): GetPropertyContacts200Response {
    return GetPropertyContacts200ResponseFromJSONTyped(json, false);
}

export function GetPropertyContacts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPropertyContacts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(PropertyLinkedContactFromJSON)),
        'meta': json['meta'] == null ? undefined : GetOrganizationProperties200ResponseMetaFromJSON(json['meta']),
    };
}

export function GetPropertyContacts200ResponseToJSON(json: any): GetPropertyContacts200Response {
    return GetPropertyContacts200ResponseToJSONTyped(json, false);
}

export function GetPropertyContacts200ResponseToJSONTyped(value?: GetPropertyContacts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contacts': ((value['contacts'] as Array<any>).map(PropertyLinkedContactToJSON)),
        'meta': GetOrganizationProperties200ResponseMetaToJSON(value['meta']),
    };
}

